// src/services/tickers-v2-service/index.ts

import api from '@/services/api'
import type { TickersFilter, TickersResponse, TickersSortingKey } from './types'
import type { SortOrder } from '../alerts-v2-service/types'

export const TickersV2Service = {
  fetchTickers(
    page: number,
    filters: TickersFilter,
    sortField: TickersSortingKey,
    sortOrder: SortOrder,
  ) {
    return api.post<TickersResponse>(
      `/v2/tickers?page=${page}&sort_field=${sortField}&sort_order=${sortOrder}`,
      filters,
    )
  },
}
